export default class Bookmarkable {
  constructor(){
    N2.offHandle('click', '.js-bookmark')
    this.registerListeners();
    this.reviveBookmarks();
    if (localStorage.getItem('bookmarks') == null){
      localStorage.setItem('bookmarks', JSON.stringify([]))
    }
  }

  check($ele) {
    $ele.children().text('bookmark').addClass('bookmark')
  }

  getBookmarks() {
    return JSON.parse(localStorage.getItem('bookmarks'))
  }

  registerListeners() {
    N2.handle('click', '.js-bookmark', (e) => {
      e.preventDefault();
      if ($(e.currentTarget).children().text() == "bookmark_border") {
        this.check($(e.currentTarget))
        this.storeBookmark($(e.currentTarget).data('id'))
      } else {
        this.unCheck($(e.currentTarget))
        this.removeBookmark($(e.currentTarget).data('id'))
      }
    })
  }

  reviveBookmarks() {
    let bm = this.getBookmarks()
    if (bm != undefined && bm.length) {
      bm.forEach((id) => {
        this.check($(`.js-bookmark[data-id='${id}']`))
      })
    }
  }

  storeBookmark(id) {
    let bm = this.getBookmarks()
    bm.push(id)
    localStorage.setItem('bookmarks', JSON.stringify(bm))
  }

  removeBookmark(id) {
    let bm = this.getBookmarks()
    bm.splice($.inArray(id, bm),1);
    localStorage.setItem('bookmarks', JSON.stringify(bm))
  }

  unCheck($ele) {
    $ele.children().text("bookmark_border").removeClass('bookmark')
  }
}
